export default {
  meta: {
    title: '报价'
  }
};
